import styled from "styled-components";
import { BrowserView, MobileView, isMobile } from "react-device-detect";
import closeIcon from "./assets/ic-close.svg";

const Container = (props) => {
  return (
    <>
      <BrowserView>
        <BrowserContainer>{props.children}</BrowserContainer>
      </BrowserView>
      <MobileView>
        <MobileContainer>{props.children}</MobileContainer>
      </MobileView>
    </>
  );
};

const BrowserContainer = styled.div`
  position: absolute;
  top: 24px;
  right: 40px;
  background-color: ${(props) => props.theme.color.background.primary};
  box-shadow: 0px 8px 20px #1e1d2a;
  border-radius: 12px;
`;

const MobileContainer = styled.div``;

const CollapsedContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CollapsedIcon = styled.img`
  margin: 12px 12px 12px 24px;
  width: 40px;
  height: 40px;
`;

const CollapsedTitle = styled.span`
  font-size: ${(props) => props.theme.font.size.primary};
  font-weight: 600;
  margin-right: 24px;
  color: ${(props) => props.theme.color.text.primary};
`;

const Collapsed = (props) => {
  return (
    <>
      <BrowserView>
        <CollapsedContainer onClick={props.onClick}>
          <CollapsedIcon src={props.icon} />
          <CollapsedTitle>{props.children}</CollapsedTitle>
        </CollapsedContainer>
      </BrowserView>
      <MobileView />
    </>
  );
};

const ExpandedTitleContainer = (props) => {
  return (
    <>
      <BrowserView>
        <BrowserExpandedTitleContainer>{props.children}</BrowserExpandedTitleContainer>
      </BrowserView>
      <MobileView>
        <MobileExpandedTitleContainer>{props.children}</MobileExpandedTitleContainer>
      </MobileView>
    </>
  );
};

const BrowserExpandedTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 24px 24px 16px 24px;
`;

const MobileExpandedTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const ExpandedTitle = styled.span`
  font-size: ${(props) => props.theme.font.size.primary};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
`;

const ExpandedClose = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
  &:hover {
    opacity: 90%;
  }
`;

const Expanded = (props) => {
  return (
    <ExpandedTitleContainer>
      <ExpandedTitle>{props.children}</ExpandedTitle>
      <ExpandedClose src={closeIcon} onClick={props.onClose} />
    </ExpandedTitleContainer>
  );
};

const ScrollableContainer = styled.div`
  margin-top: 16px;
  overflow-y: auto;
  min-width: ${isMobile ? "100%" : "30vw"};
  max-width: ${isMobile ? "100%" : "45vw"};
  max-height: 74vh;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px transparent;
    -webkit-border-radius: 4px;
    border-radius: 4px;
  }
  :hover {
    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: ${(props) => props.theme.color.background.light};
    }
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-border-radius: 4px;
      border-radius: 4px;
    }
  }
`;

const ItemsContainer = (props) => {
  return (
    <>
      <BrowserView>
        <BrowserItemsContainer>{props.children}</BrowserItemsContainer>
      </BrowserView>
      <MobileView>
        <MobileItemsContainer>{props.children}</MobileItemsContainer>
      </MobileView>
    </>
  );
};

const BrowserItemsContainer = styled.div`
  padding-bottom: 24px;
`;

const MobileItemsContainer = styled.div``;

const ItemContainer = (props) => {
  return (
    <>
      <BrowserView>
        <BrowserItemContainer>{props.children}</BrowserItemContainer>
      </BrowserView>
      <MobileView>
        <MobileItemContainer>{props.children}</MobileItemContainer>
      </MobileView>
    </>
  );
};

const BrowserItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  margin-right: 24px;
`;

const MobileItemContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ItemTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
  gap: 8px;
`;

const ItemTitleZoneIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const ItemTitleName = styled.span`
  font-size: ${(props) => props.theme.font.size.primary};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
`;

const ItemDescription = styled.span`
  font-size: ${(props) => props.theme.font.size.disclaimer};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
  margin-top: 8px;
`;

const ItemDetails = styled.span`
  font-size: ${(props) => props.theme.font.size.disclaimer};
  font-weight: 600;
  color: ${(props) => props.theme.color.accent};
  text-align: center;
  cursor: pointer;
  &:hover {
    opacity: 90%;
  }
`;

const ItemTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  opacity: ${(props) => (props.isOpacity ? 0.7 : 1)};
`;

const Item = (props) => {
  return (
    <ItemContainer>
      <ItemTopContainer isOpacity={props.isOpacity}>
        <ItemTitleName>{props.name}</ItemTitleName>
        <ItemDescription>{props.description}</ItemDescription>
      </ItemTopContainer>
      <ItemTitleContainer>
        <ItemTitleZoneIcon src={require(`./assets/ic-zone-${props.zone}.png`)} />
        <ItemDetails onClick={props.onClickDetails}>View details</ItemDetails>
      </ItemTitleContainer>
    </ItemContainer>
  );
};

const Spacer = (props) => {
  return (
    <>
      <BrowserView>
        <BrowserSpacer>{props.children}</BrowserSpacer>
      </BrowserView>
      <MobileView>
        <MobileSpacer>{props.children}</MobileSpacer>
      </MobileView>
    </>
  );
};

const BrowserSpacer = styled.div`
  border-top: 1px solid white;
  opacity: 12%;
  margin: 24px 16px 24px 16px;
`;

const MobileSpacer = styled.div`
  border-top: 1px solid white;
  opacity: 12%;
  margin: 16px 0 16px 0;
`;

export { Container, Collapsed, Expanded, ScrollableContainer, ItemsContainer, Item, Spacer };
